import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Rx';

import { Counter } from '../counter.model';
import { Campaign } from '../../campaigns/campaign.model';
import { CounterService } from '../counter.service';

@Component({
  selector: 'wm-counter-edit',
  template: require('./counter-edit.component.html')
})

export class CounterEditComponent implements OnInit {
  @Input() campaign: Campaign;
  @Output() counterAdd = new EventEmitter();

  counter: Counter;
  counters: Counter[];

  loading = true;

  counterForm: FormGroup;
  submitted: boolean;
  formErrors: Object;

  usage_types = ['pageview', 'event', 'trans', 'item', 'social', 'exception'];

  validationMessages = {
    'name': {
      required: 'Имя не указано'
    },
    'total': {
      pattern: 'Неверное количество'
    }
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private service: CounterService
  ) { }

  ngOnInit() {
    this.initFormErrors();
    this.buildForm();
    this.submitted = false;
  }

  buildForm() {
    this.counterForm = this.fb.group({
      name: ['', [Validators.required]],
      usage_type: [''],
      total: ['', [Validators.pattern('^[0-9]+$')]]
    });
  }

  initFormErrors() {
    this.formErrors = {name: '', usage_type: '', total: ''};
  }

  onSubmit(model: Counter, valid: boolean) {
    this.submitted = true;

    if (!valid) {
      this.validateForm();

      return false;
    }

    if (!model.usage_type) {
      delete model.usage_type;
    }

    this.service.createCounter(this.campaign.id, model).subscribe(result => {
      this.counterAdd.emit(result['counter']);
      this.initFormErrors();
      this.buildForm();
      this.submitted = false;
    });

    return false;
  }

  validateForm() {
    for (let field of Object.keys(this.formErrors)) {
      this.formErrors[field] = '';
      let input = this.counterForm.get(field);

      if ((input.invalid && input.dirty) || this.submitted) {
        if (!!input.errors) {
          for (let error of Object.keys(input.errors)) {
            this.formErrors[field] = this.validationMessages[field][error];
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/counters/components/counter-edit.component.ts